<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/memberDiary/subCategory')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validate">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="addData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Category</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="category" v-validate="'required'" v-model="addData.member_pt_diary_category_id" class="mb-3">
                        <option v-for="row in categories" :value="row.id" :key="row.id">{{ row.name }}</option>
                    </b-form-select>
                  </div>
                  <span class="error">{{ errors.first('category') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'

export default {
  name: 'memberDiarySubCategoryManage',
  data: function () {
    return {
      addData: {
        name: '',
        member_pt_diary_category_id: ''
      },
      categories: []
    }
  },
  methods: {
    async validate () {
        let isValid = await this.$validator.validateAll()
      
        if (!isValid) {
            this.$toast.success('please fill in required fields!', 'Error', {
                position: 'topCenter',
                icon: 'icon-envelope',
                progressBarColor: 'rgb(0, 255, 184)',
                theme: 'dark',
                backgroundColor: '#565c70',
                messageColor: '#fff'
            })

            return
        }

        try {
            let methods = (this.$route.params.id) ? 'put' : 'post'
            let id = this.$route.params.id || ''
            let response = await axios[methods]('crm/v1/member_pt_diary_subcategory/' + id , this.addData)
            this.$router.push('/memberDiary/subCategory')
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
        } catch (error) {
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
        }
    },
    async getCategories () {
        axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
        let response = await axios.get('crm/v1/member_pt_diary_category/')
        this.categories = response.data.data
        this.addData.member_pt_diary_category_id = this.categories[0].id
    },
    openPage (event) {
      this.$router.push(event)
    },
    async getData () {
        if (!this.$route.params.id) return
        try {
            let response = await axios.get('crm/v1/member_pt_diary_subcategory/' + this.$route.params.id)
            this.addData.member_pt_diary_category_id = response.data.data.member_pt_diary_category_id
            this.addData.name = response.data.data.name
        } catch (error) {
            this.$toast.error(error.message)
        }
    }
  },
  async mounted () {
      await this.getCategories()
      await this.getData()
  }
}
</script>

<style lang="scss" scoped>
</style>
